import Isochrone from './Isochrone';

export default Isochrone;
